module.exports = __webpack_public_path__ + "static/img/tw.8083973f.png";